import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import CarouselHome from '../components/CarouselHome';
import IRCAllActivities from '../components/IRCAllActivities';
import BlogFront from '../components/BlogFront';
import VideoGallery from '../components/VideoGallery';
import ImageGallery from '../components/ImageGallery';
import DonationSection from '../components/DonationSection';
import DonationSectionAnotherWithoutButton from '../components/DonationSectionAnotherWithoutButton';
import SocialSection from '../components/SocialSection';
import ContactUs from '../pages/ContactUs';
import ActivityVideos from '../pages/ActivityVideos';
import OurWebsites from '../components/OurWebsites';
import Footer from '../components/Footer';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import aboutus2 from '../images/aboutus2.jpg';
import aboutus from '../images/aboutus.png';
import { 
    FaTimes,
  FaExpand
} from 'react-icons/fa';

const Home = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [imageLoaded, setImageLoaded] = useState({
        aboutus2: false,
        aboutus: false
    });

    const handleReload = () => {
        window.scrollTo(0, 0);
    };

    const openPopup = () => {
        setIsPopupOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        document.body.style.overflow = 'auto';
    };

    const handleImageLoad = (imageName) => {
        setImageLoaded(prev => ({
            ...prev,
            [imageName]: true
        }));
    };

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    return (
        <>
            <CarouselHome />
            <div className="about-us-container">
                {/* Home Section */}
                <section className="home-section" id="about">
                    {/* First container - image on right */}
                    <div className="home-container">
                        <div className="home-content">
                            <h2>About IRC – Islamic Research Centre</h2>
                            <p className='justified-text'>
                                What began as the heartfelt effort of one-man Adv. Faiz Syed to make authentic Islamic knowledge simple, accessible, and free from confusion has grown into a global movement followed by millions. Driven by sincerity and a commitment to truth, the Islamic Research Centre (IRC) simplifies the core teachings of Islam using evidence from Qur'an and Hadith, bridging the gap between tradition and modern understanding. IRC aims to remove barriers of language, misinformation, and outdated beliefs translating complex texts into practical, easy-to-apply guidance. But our work doesn't stop at knowledge. IRC extends its mission through compassion offering education, affordable healthcare, women-centric support, mental health counselling, career guidance, skill development, and dignity-driven welfare programs for the needy. From clean water and free food to professional training and public awareness IRC works to uplift lives, regardless of background or belief. With every life we touch, we carry the sacred trust of our supporters, donors, volunteers, and well-wishers and remain steadfast in our commitment to serve with sincerity, excellence, and purpose.
                            </p>
                            <Link to="/about" className="learn-more-btn" onClick={handleReload}>
                                Learn More
                            </Link>
                        </div>
                        <div className="home-image clickable-image-container">
                            <img 
                                src={aboutus2} 
                                alt="Our home" 
                                loading="lazy" 
                                onClick={openPopup}
                                className="clickable-image"
                                onLoad={() => handleImageLoad('aboutus2')}
                                style={{
                                    opacity: imageLoaded.aboutus2 ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                            />
                            {!imageLoaded.aboutus2 && (
                                <div className="image-placeholder">
                                    Loading...
                                </div>
                            )}
                            <div onClick={openPopup} className="image-click-indicator">
                                <FaExpand className="expand-icon" />
                                <span>Click to enlarge</span>
                            </div>
                        </div>
                    </div>

                    {/* Image Popup */}
                    {isPopupOpen && (
                        <div className="image-popup-overlay" onClick={closePopup}>
                            <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
                                <button className="popup-close-btn" onClick={closePopup}>
                                    <FaTimes />
                                </button>
                                <img 
                                    src={aboutus2} 
                                    alt="Our home - enlarged" 
                                    loading="eager" // Use eager loading for popup since it's user-requested
                                />
                            </div>
                        </div>
                    )}

                    {/* Second container - image on left */}
                    <div className="home-container reverse">
                        <div className="home-image">
                            <img 
                                src={aboutus} 
                                alt="Our Founder" 
                                loading="lazy" 
                                onLoad={() => handleImageLoad('aboutus')}
                                style={{
                                    opacity: imageLoaded.aboutus ? 1 : 0,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                            />
                            {!imageLoaded.aboutus && (
                                <div className="image-placeholder">
                                    Loading...
                                </div>
                            )}
                        </div>
                        <div className="home-content">
                            <h2>Our Founder – Adv. Faiz Syed</h2>
                            <p className='justified-text'>
                                Adv. Faiz Syed, the founder and president of IRC, is a renowned Indian Islamic speaker and social reformer. With over 2000 Urdu lectures and countless open Q&A sessions, his mission has always been clear: to clarify Islam with wisdom, evidence, and compassion. His dedication to education and upliftment—especially of youth and women—has made him an influential figure. Adv. Faiz Syed was also featured in the Top 100 Most Influential Indian Muslims of 2025 by Muslim Mirror, a recognition of his widespread impact and leadership within the community. IRC is a living extension of his vision: spreading truth, challenging misguidance, and serving humanity through the lens of Islam’s values of justice, mercy, and love.
                            </p>
                            <Link to="/underdevelopment" className="learn-more-btn" onClick={handleReload}>
                                Learn More
                            </Link>
                        </div>
                    </div>
                </section>

                {/* Rest of your components remain the same */}
                <section className="home-values-section" id="activities">
                    <div className="values-header">
                        <h2>Our Activities</h2>
                        <Link to="/activities.html" className="activities-button" onClick={handleReload}>
                            View All Activities
                        </Link>
                    </div>
                    <IRCAllActivities />
                </section>
                
                <div className="scroll-section" id="news-media">
                    <BlogFront />
                </div>
                <div className="scroll-section" id="videos">
                    <VideoGallery />
                </div>
                <div className="scroll-section" id="images">
                    <ImageGallery />
                </div>
                <div className="scroll-section" id="help-us">
                    <DonationSection />
                </div>
                <div className="scroll-section" id="help-us">
                    <DonationSectionAnotherWithoutButton />
                </div>
                <div className="scroll-section" id="social-connects">
                    <SocialSection />
                </div>
                <div className="scroll-section">
                    <OurWebsites />
                </div>
                  <div className="scroll-section" id="contacts">
                    <ActivityVideos />
                </div>
                <div className="scroll-section" id="contacts">
                    <ContactUs />
                </div>
                <div id="footer">
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default Home;